
import React, { useEffect, useState } from 'react'
import { postData, getData } from '../../../../../ApiServices/ApiService';
import {
  ORG_GET_ACCOUNTS_LIST, ORG_GET_GROUP_LIST, ORG_GET_SERVICE_LIST_SEARCH,
  ORG_GET_EMPLOYEE_LIST, ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_GET_CLIENT_TYPE_LIST
} from '../../../../../ApiServices/BaseURL';
import { useTheme } from '../../../../../GlobalContext/GlobalContext';

const InvoiceAccountsController = () => {
  const { setIsLoginPopup } = useTheme();
  const [filterValues, setFilterValues] = useState({
    clientName: null,
    clientType: null,
    gstinNo: "",
    pendingTask: null,
    city: "",
    assignedTo: null,
    groupName: null,
    services: null,
    panNo: "",
  });

  const [showFilters, setShowFilters] = useState(true);
  const [filterError, setFilterError] = useState('');
  
  const handleFilterChange = (field, value) => {
    setFilterValues((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const [accountsList, setAccountsList] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [listError, setListError] = useState('')


  const [clientList, setClientList] = useState([]);
  const [searchUser, setSearchUser] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState('');

  const [clientTypeError, setClientTypeError] = useState('')
  const [clientType, setClientType] = useState([]);
  const [clientTypeLoading, setClientTypeLoading] = useState(false)

  const [groupNameError, setGroupNameError] = useState('')
  const [groupName, setGroupName] = useState([]);
  const [groupNameLoading, setGroupNameLoading] = useState(false)

  const [servicesSearchList, setServicesSearchList] = useState([]);
  const [seriveError, setServiceError] = useState('')
  const [serviceLoading, setServiceLoading] = useState(false)

  const [userLoading, setUserLoading] = useState(false);
  const [userError, setUserError] = useState('');
  const [recipientOptions, setRecipientOptions] = useState([]);

  useEffect(() => {
    fetchAccountsList('LIST');
    fetchClientTypesList();
    fetchGroupList();
    fetchTaskServicesSearchList();
    fetchUserList();
  }, [])

  const fetchAccountsList = async (type) => {
    try {
      //console.log('get categoty')
      setListLoading(true);
      setAccountsList([]);
      setListError('');
      setCurrentPage(1)
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      var payLoad;
      if(type === 'SEARCH'){
        payLoad = {
          "emp_id_auth": storedUserInfo?.emp_id,
          "action":"SEARCH",
          "client_id": filterValues?.clientName?.client_id || 0,
          "client_type": filterValues?.clientType?.value || 0,
          "service_id":filterValues?.services?.value,
          "client_gstin": filterValues?.gstinNo || '',
          "client_city": filterValues?.city || '',
          "group_id": filterValues?.groupName?.value || 0,
          "emp_id_incharge": filterValues?.assignedTo?.value || 0,
          "task_status": filterValues?.pendingTask?.value || 0,
          "client_pan_no":filterValues?.panNo || ''
        }
      }else{
        payLoad = {
          "emp_id_auth": storedUserInfo?.emp_id,
          "action":"LIST",
        }
      }




      console.log('account payLoad:-',payLoad);

      // Make the API call
      // const response = await getData(`${ORG_GET_ACCOUNTS_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const response = await postData(ORG_GET_ACCOUNTS_LIST, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              setAccountsList(responseData?.dataJ);
            } else {
              setListError(responseData?.info || 'Data Not Found');
            }
          } else {
            setListError(responseData?.info || 'Failed to fetch accounts details. Please try again.');
          }
        } else {
          setListError(responseData?.info || 'Failed to fetch accounts details. Status code error.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setListError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setListError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setListError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setListError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setListError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch accounts details. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setListError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setListError(`Failed to fetch accounts details. Please check your network connection and try again.`);
      }
    } finally {
      setListLoading(false);
    }
  }


  const getStatusStyle = (status) => {
    switch (status) {
      case "Advance Payment":
        return { backgroundColor: "rgba(226, 177, 51, 0.18)", color: "rgba(223, 165, 16, 1)" }; // yellow
      case "Overdue":
        return { backgroundColor: "rgba(238, 32, 28, 0.18)", color: "rgba(238, 32, 28, 1)" }; // red
      case "Paid":
        return { backgroundColor: "rgba(26, 147, 46, 0.18)", color: "rgba(26, 147, 46, 1)" }; // green
      default:
        return {};
    }
  };

  const handleSearchInputText = (value) => {
    setSearchUser(value);
    setSearchError('');
    setClientList([]);
    if (!value) {
      setFilterValues((prevData) => ({
        ...prevData,
        clientName: null,
      }));
    }
  };

  const handleSelectClient = (client) => {
    handleFilterChange('clientName', client);
    setSearchUser(client?.client_name);
    setClientList([]);
  };

  const handleSearchClient = async () => {
    try {
      setSearchError('');
      setSearchLoading(true);
      setClientList([]);
      if (!searchUser) {
        setSearchError('Please enter valid text'); return;
      }
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

      //console.log('team Data', payLoad);
      // Make the API call
      const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setClientList(responseData?.dataJ || []);
          } else {
            setSearchError(responseData?.info || 'Failed to fetch client. Please try again.');
          }
        } else {
          setSearchError(responseData?.info || 'Failed to fetch client. Status code error.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setSearchError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setSearchError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setSearchError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setSearchError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setSearchError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch client. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setSearchError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setSearchError(`Failed to fetch client. Please check your network connection and try again.`);
      }
    } finally {
      setSearchLoading(false);
    }
  };


  const fetchClientTypesList = async () => {
    setClientTypeError('')
    try {
      setClientTypeLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_CLIENT_TYPE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              // Transforming the data
              const dropdownOptions = responseData?.dataJ.map((type) => ({
                label: type.client_type_name,
                value: type.client_type_id,
              }));

              setClientType(dropdownOptions)
              //console.log('type list',responseData?.dataJ)
            } else {
              setClientTypeError(responseData?.info || 'Data Not Found');
            }
          } else {
            setClientTypeError(responseData?.info || 'Failed to fetch data. Please try again.');
          }
        } else {
          setClientTypeError(responseData?.info || 'Something went wrong while processing your request.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setClientTypeError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setClientTypeError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
        setIsLoginPopup(true)
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setClientTypeError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setClientTypeError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setClientTypeError(`Error: ${error.response.status}. ${error.response.data?.message || 'Something went wrong while processing your request. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setClientTypeError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setClientTypeError(`Something went wrong while processing your request. Please check your network connection and try again.`);
      }
    } finally {
      setClientTypeLoading(false);
    }
  }

  const ItemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(accountsList.length / ItemsPerPage);

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate the index of the first and last items on the current page
  const indexOfLastItem = currentPage * ItemsPerPage;
  const indexOfFirstItem = indexOfLastItem - ItemsPerPage;

  // Slice the data for the current page
  const currentAccountsList = accountsList.slice(indexOfFirstItem, indexOfLastItem);
  const maxVisiblePages = 3;

  const getVisiblePages = () => {
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if we're near the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  };

  const visiblePages = getVisiblePages();

  const fetchGroupList = async () => {
    try {
      setGroupNameError('')
      setGroupNameLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_GROUP_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              // Transforming the data

              const dropdownOptions = responseData?.dataJ.map((type) => ({
                label: type.group_name,
                value: type.group_id,
              }));
              setGroupName(dropdownOptions)
            } else {
              setGroupNameError(responseData?.info || 'Data Not Found');
            }
          } else {
            setGroupNameError(responseData?.info || 'Failed to fetch data. Please try again.');
          }
        } else {
          setGroupNameError(responseData?.info || 'Something went wrong while processing your request.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setGroupNameError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setGroupNameError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setGroupNameError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setGroupNameError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setGroupNameError(`Error: ${error.response.status}. ${error.response.data?.message || 'Something went wrong while processing your request. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setGroupNameError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setGroupNameError(`Something went wrong while processing your request. Please check your network connection and try again.`);
      }
    } finally {
      setGroupNameLoading(false);
    }
  }

  const fetchTaskServicesSearchList = async () => {
    try {
      //console.log('fetchTaskServicesSearchList')
      setServiceError('')
      setServiceLoading(true);
      setServicesSearchList([]);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = {
        "emp_id_auth": storedUserInfo?.emp_id
      }

      //console.log('fetchTaskServicesSearchList payload',payLoad);

      // Make the API call
      const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payLoad);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const filterValues = await responseData?.dataJ.map(service => ({
                label: service.service_name,
                value: service.service_id
              }));
              setServicesSearchList(filterValues);
            } else {
              setServiceError(responseData?.info || 'Data Not Found');
            }
          } else {
            setServiceError(responseData?.info || 'Failed to fetch data. Please try again.');
          }
        } else {
          setServiceError(responseData?.info || 'Something went wrong while processing your request.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setServiceError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setServiceError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setServiceError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setServiceError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setServiceError(`Error: ${error.response.status}. ${error.response.data?.message || 'Something went wrong while processing your request. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setServiceError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setServiceError(`Something went wrong while processing your request. Please check your network connection and try again.`);
      }
    } finally {
      setServiceLoading(false);
    }
  }

  const fetchUserList = async () => {
    try {
      setUserLoading(true);
      setUserError('');

      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      // Make the API call
      const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
      const responseData = await response.json();

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            if (responseData?.dataJ?.length > 0) {
              const formattedTeams = responseData.dataJ.map(service => ({
                label: service.emp_name,
                value: service.emp_id
              }));
              setRecipientOptions(formattedTeams);
            } else {
              setUserError(responseData?.info || 'Data Not Found');
            }
          } else {
            setUserError(responseData?.info || 'Failed to fetch User data. Please try again.');
          }
        } else {
          setUserError(responseData?.info || 'Failed to fetch User data. Status code error.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setUserError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setUserError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setUserError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setUserError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setUserError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setUserError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setUserError(`Failed to fetch User data. Please check your network connection and try again.`);
      }
    } finally {
      setUserLoading(false);
    }
  }

  const cancelFilters = () => {
    resetFilters();
    setShowFilters(!showFilters);
  }

  const resetFilters = () => {
    setFilterValues({
      clientName: "",
      clientType: null,
      gstinNo: "",
      pendingTask: null,
      city: "",
      assignedTo: null,
      groupName: null,
      services: null,
      panNo:""
    });
    setClientList([]);
    setSearchUser('');
    setSearchError('');
    setListError('');
    setFilterError('')
    if (filterValues?.clientName || filterValues?.services || filterValues?.clientType || filterValues?.city || filterValues?.assignedTo || filterValues?.groupName || filterValues?.pendingTask || filterValues?.gstinNo || filterValues?.panNo) {
      fetchAccountsList('LIST');
      setCurrentPage(1);
    }
  };
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const applyFilters = () => {
    console.log('apply');
    setFilterError('');
    if (!(filterValues?.clientName || filterValues?.services || filterValues?.clientType || filterValues?.city || filterValues?.assignedTo || filterValues?.groupName || filterValues?.pendingTask || filterValues?.gstinNo || filterValues?.panNo)) {
      setFilterError('Please enter/select any one of the above');
      return;
    }
    fetchAccountsList('SEARCH');
  };
  return {
    currentAccountsList,
    getStatusStyle,
    setFilterValues,
    filterValues,
    handleFilterChange,
    handleSearchClient,
    searchLoading,
    searchError,
    clientList,
    searchUser,
    handleSearchInputText,
    handleSelectClient,
    listError, listLoading,
    clientTypeLoading,
    clientType,
    clientTypeError,
    handlePageChange,
    totalPages, visiblePages,
    currentPage,
    groupName,
    groupNameError,
    groupNameLoading,
    seriveError,
    servicesSearchList,
    serviceLoading,
    recipientOptions,
    userLoading,
    userError,
    applyFilters,
    cancelFilters,
    resetFilters,filterError,
    toggleFilters,showFilters
  }

}

export default InvoiceAccountsController